module.exports = __webpack_public_path__ + "images/137_320.jpg";